import { Shield, Lock } from "lucide-react";
import { useTranslation } from "@/lib/i18n.jsx";

export const TrustBadge = () => {
  const { t } = useTranslation();
  return (
    <div className="trust-badge animate-fade-in">
      <div className="flex items-center gap-1.5">
        <Shield className="w-3 h-3 text-success" />
        <Lock className="w-3 h-3 text-success" />
      </div>
      <span className="text-[12px] trust-badge-text flex items-center">
        {t('widget.trust_badge.powered_by', 'Secured by')}
        <picture className="block dark:hidden">
          <source srcSet="/mainlogoblack.webp" type="image/webp" />
          <img src="/mainlogoblack.png" className="h-5 w-auto" alt="Palzea" />
        </picture>
        <picture className="hidden dark:block">
          <source srcSet="/mainlogo.webp" type="image/webp" />
          <img src="/mainlogo.png" className="h-5 w-auto" alt="Palzea" />
        </picture>
      </span>
    </div>
  );
};
